import React from 'react'
import Tr from 'translations/Translations';
import LaunchIcon from '@material-ui/icons/Launch';
import WorkableIconButton from "./WorkableIconButton";
import PropTypes from "prop-types";

function WorkableIconPublishButton(
    {
        tooltip = Tr('publish'),
        ...props
    }) {
    return <WorkableIconButton
        Icon={LaunchIcon}
        tooltip={tooltip}
        {...props}
    />
}

WorkableIconPublishButton.propTypes = {
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    hideTooltip: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default WorkableIconPublishButton;